import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";

export const registerCorporate = async (postData: any) => {
  try {
    return await post<ApiResponse<[]>>('/corporate/register', postData).then((res) => {
      if (res.success === true) {
        SuccessMessage("API.SUCCESS.CORPORATE.REGISTER");
        return res;
      } else {
        toast.error(res.error.message);
        return null;
      }
    });
  } catch (e: any) {
    HandleApiError(e);
  }
};
